import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import EmptyData from 'components/commons/EmptyData';
import { TagList } from 'components/commons';
import {
  formatNum,
  getStatus,
  getIssueDetailUrlPrefix,
  convertIssueAssigneeListToDisplayText,
} from 'utils/helper';
import _style from './style.scss';
import { very_dirty_table_hack } from 'components/exception/ProductSummaryPage/style.scss';
import { Translation, useTranslation } from 'react-i18next';
import IssueTrendBarChart from 'components/exception/BaseProblemPage/IssueItem/IssueTrendBarChart';
import { Space, Tooltip, Table, Button, Row, Col, Select, Radio, InputNumber, DatePicker } from 'antd';
import { getIsIframe } from 'utils/iframe';
import moment from 'moment';
import SortButton from 'components/exception/ProductSummaryPage/SortButton';
import { formatEnNumber } from 'utils/format/format-number';
import useDeepCompareEffect from 'use-deep-compare-effect';
import CsClampDiv from 'components/commons/CsClampDiv/CsClampDiv';
import { useImmer } from 'use-immer';
import { DemoUtil } from 'utils/demo-util';
import { TimeUtil } from 'utils/time-util';
import { ze, isZh } from 'utils/zhEn';
import IssueTapdBugStatusEx from 'components/exception/BaseProblemPage/IssueItem/IssueTapdBugStatusEx';
import { connect, useSelector } from 'react-redux';
import { IssueListTrendTypeEnum } from 'utils/constants';
import CardHead from 'components/commons/CardHead';
import TopIssuesIcon from 'svg/v2/newcs_dashboard_overview_dailytopissue_icon.svg';
import { UpdateTimeTag } from '../UpdateTimeTag';
import reportEvent, { EVENT_ACTIONS, ReportEventUtil } from 'utils/reportEvent';
import { CsvUtil } from 'utils/csv-util';
import { ALL_VERSION } from 'utils/constants';
import { isNotNullish } from 'utils/nullish';
import VersionHybridSelect from 'components/commons/VersionHybridSelect';
import SingleOrRangeDatePicker from 'components/exception/ProductSummaryPage/SingleOrRangeDatePicker';
import { selectCurrentAppDatePickerAvailableMomentRange } from 'utils/selectors/selectors';
import { CountryUtil } from 'utils/country';
import CountrySelect from '../CountrySelect';
import * as platformUtils from 'utils/platform';
import { DocsUtil } from 'utils/docs-util';
import { VersionUtil } from 'utils/version-util';
import { orange } from '@ant-design/colors';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import IssueCrashFilter, { IssueCrashFilterUtil } from 'components/commons/IssueCrashFilter/IssueCrashFilter';
import pickBy from 'lodash.pickby';
import IssueIdIcon from 'svg/v2/newcs_dashboard_overview_dailytopissue_list_issueid_icon.svg';
import IssueNameIcon from 'svg/v2/newcs_dashboard_overview_dailytopissue_list_yichangname_icon.svg';
import UpIcon from 'svg/v2/newcs_dashboard_list_up_icon.svg';
import DownIcon from 'svg/v2/newcs_dashboard_list_down_icon.svg'
import CsDownloadButton from 'components/commons/CsDownloadButton/CsDownloadButton';
import CsCollapseButton from 'components/commons/CsCollapseButton/CsCollapseButton';
import StatusItem from 'components/commons/StatusItem/StatusItem';
import WrappedTipsIcon from 'components/antd-extension/WrappedTipsIcon.jsx';
import { CS_STYLES } from 'utils/constants/style-constants';
import { PlatformUtil } from 'utils/platform';
import VmTypeSelect from 'components/exception/ProductSummaryPage/VmTypeSelect';
import UserSceneTagSelect from 'components/exception/ProductSummaryPage/UserSceneTagSelect';
import { VmTypeUtil } from 'utils/constants/vm-type';
import { ExceptionCategoryUtil } from 'utils/exception-category';
import { TopIssueJankType } from 'utils/constants/top-issue-jank-type';
import WangZheTopFormList from 'components/exception/ProductSummaryPage/TopIssueList/WangZheTopFormList';
import { getTopIssue } from 'reducers/summary/summaryActions';
import SubJankIssueFlameGraphModal
  from 'components/exception/ProductSummaryPage/TopIssueList/SubJankIssueFlameGraphModal';
import { useInViewport } from 'ahooks';
import { ix } from 'utils/i18n-with-context';
import DateSelectIcon from 'svg/v2/newcs_dashboard_dateselect_icon.svg';
import { buildTopIssueWebsiteUrl } from './topIssueJumpUrl';
import i18n from 'i18n.js';
import SummaryScss from 'components/exception/ProductSummaryPage/style.scss';
import VitalOrCrashSelect from 'components/exception/ProductSummaryPage/VitalOrCrashSelect';
import SearchItemScss from 'components/exception/SeniorSearchPage/SearchItem/style.scss';
import { BillingTeamType } from 'utils/constants/billing';
import { TopIssueWangZheExpNameType } from 'utils/constants/top-issue-wang-zhe-exp-name-type';
import IssueCrashFilterEx from 'components/commons/IssueCrashFilter/IssueCrashFilterEx';
import {FieldName, QueryType} from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import {ServerAppSettings} from 'utils/server-app-settings';

const FIELDS = Object.freeze({
  DEVICES: 'DEVICES',
  REPORT_COUNT: 'REPORT_COUNT',
  FLUCTUATE: 'FLUCTUATE',
  FIRST_TIME: 'FIRST_TIME',
  TOTAL_DEVICES: 'TOTAL_DEVICES',
  TOTAL_NUM: 'TOTAL_NUM',
});

function formatRate(numerator, denominator) {
  if (parseInt(denominator) === 0) {
    return '0 %';
  }
  return TopIssueUtils.formatPercentage(100 * numerator / denominator);
}

export const TopIssueCompareType = Object.freeze({
  PREV_DAY: 'PREV_DAY',
  PREV_HOUR: 'PREV_HOUR',
  CUSTOM: 'CUSTOM',
})

export const TopIssueSortField = Object.freeze({
  DEVICE_COUNT: 'DEVICE_COUNT',
  REPORT_COUNT: 'REPORT_COUNT',
  JANK_TIME: 'JANK_TIME',
});

const WangZheExpNameTypeOptions = [
  { value: TopIssueWangZheExpNameType.ALL, label: '不限' },
  { value: TopIssueWangZheExpNameType.IN_BATTLE, label: '局内' },
  { value: TopIssueWangZheExpNameType.OUT_BATTLE, label: '局外' },
];

export const TopIssueUtils = Object.freeze({
  /**
   * 王者定制需求，哪些异常名算局内
   * --story=128008412 【CS】王者荣耀的局内卡顿，在筛选查找界面可以区分统计，查看
   * */
  getWangZheInBattleExpNameList() {
    return [
      'Loading_Current',
      'Loading_Total',
      'Battle_Current',
      'Battle_Total',
      'GameCore_Current',
      'GameCore_Total',
    ];
  },

  parseTopIssueCompareDateStr(compareDateStr, defaultCompareType) {
    if (!compareDateStr) {
      return { compareType: defaultCompareType, customDateStr: null };
    } else if (compareDateStr === TopIssueCompareType.PREV_DAY) {
      return { compareType: TopIssueCompareType.PREV_DAY, customDateStr: null };
    } else if (compareDateStr === TopIssueCompareType.PREV_HOUR) {
      return { compareType: TopIssueCompareType.PREV_HOUR, customDateStr: null };
    } else {
      return { compareType: TopIssueCompareType.CUSTOM, customDateStr: compareDateStr };
    }
  },

  calcFluctuatePercentage(crashDevices, accessDevices, compareCrashDevices, compareAccessDevices) {
    const nowRatio = accessDevices > 0 ? crashDevices / accessDevices : 0;
    const compareRatio = compareAccessDevices > 0 ? compareCrashDevices / compareAccessDevices : 0;
    if (nowRatio === compareRatio) {
      return 0;
    }
    return 100 * (nowRatio - compareRatio) / compareRatio;
  },

  calcFluctuatePercentageOfTwoValues(nowValue, compareValue) {
    if (nowValue === compareValue) {
      return 0;
    }
    return 100 * (nowValue - compareValue) / compareValue;
  },

  //这个地方和RealTimeTopIssue 里面的formatPercentage 逻辑重复
  formatPercentage(percentage, { maxDecimals, hasPlusSign } = {}) {
    const originPercentage = percentage;
    if (typeof percentage === 'string') {
      percentage = Number(percentage);
    }
    if (percentage === Number.POSITIVE_INFINITY) {
      return '∞';
    } else if (percentage === Number.NEGATIVE_INFINITY) {
      return '-∞';
    } else if (!Number.isFinite(percentage)) {
      return `${originPercentage}`;
    }
    const plusSign = (!!hasPlusSign && percentage > 0) ? '+' : '';
    if (Math.abs(percentage) >= 0.1 || percentage === 0) {
      return `${plusSign}${percentage.toFixed(maxDecimals || 2)} %`;
    }
    return `${plusSign}${percentage.toFixed(maxDecimals || 4)} %`;
  },
  makeFluctuateDom(fluctuatePercentage) {
    let arrowClassName;
    if (fluctuatePercentage > 0) {
      arrowClassName = 'increase';
    } else if (fluctuatePercentage < 0) {
      arrowClassName = 'decrease';
    }
    const style = SummaryScss;

    let textColor = undefined;
    if (fluctuatePercentage > 0) {
      textColor = '#f44336';
    } else {
      textColor = '#38b16a';
    }

    const infiniteTip = fluctuatePercentage === Number.POSITIVE_INFINITY ? i18n.t('TOPISSUELIST.infinityFluctuateTip') : undefined;
    return <div style={{ display: 'inline-block', position: 'relative', fontSize: '12px' }}>
      <Tooltip title={infiniteTip}>
        <Space size={4}>
          <div style={{ color: textColor, whiteSpace: 'nowrap' }}>{ TopIssueUtils.formatPercentage(fluctuatePercentage, { maxDecimals: 2, hasPlusSign: true }) }</div>
          {arrowClassName && <div className={`${style[arrowClassName]}`}>{arrowClassName === 'increase' ? <UpIcon /> : <DownIcon />}</div>}
          { infiniteTip && <WrappedTipsIcon /> }
        </Space>
      </Tooltip>
    </div>;
  },

  makeTopIssueEnrichedIssueList(topIssueData, topIssueDataType, topIssueCompareType) {
    const {
      topIssueList,
      crashDevices,
      accessDevices,
      prevDayAccessDevices,
      prevDayCrashDevices,
      prevDaySameHourAccessDevices,
      prevDaySameHourCrashDevices,
      prevHourAccessDevices,
      prevHourCrashDevices,
      compareDateAccessDevices,
      compareDateCrashDevices,
      compareDateCrashNum,
    } = topIssueData;

    let globalCompareDateAccessDevices = 0;
    let globalCompareDateCrashDevices = 0;
    if (topIssueCompareType === TopIssueCompareType.PREV_DAY) {
      globalCompareDateAccessDevices = prevDayAccessDevices || prevDaySameHourAccessDevices || 0;
      globalCompareDateCrashDevices = prevDayCrashDevices || prevDaySameHourCrashDevices || 0;
    } else if (topIssueCompareType === TopIssueCompareType.PREV_HOUR) {
      globalCompareDateAccessDevices = prevHourAccessDevices || 0;
      globalCompareDateCrashDevices = prevHourCrashDevices || 0;
    } else if (topIssueCompareType === TopIssueCompareType.CUSTOM) {
      globalCompareDateAccessDevices = compareDateAccessDevices || 0;
      globalCompareDateCrashDevices = compareDateCrashDevices || 0;
    }

    return topIssueList
      .map(x => {
        let issueCompareCrashNum = 0;
        let issueCompareCrashDevices = 0;
        if (topIssueCompareType === TopIssueCompareType.PREV_DAY) {
          issueCompareCrashNum = x.preDayCrashNum || 0;
          issueCompareCrashDevices = x.preDayCrashUser || 0;
        } else if (topIssueCompareType === TopIssueCompareType.PREV_HOUR) {
          issueCompareCrashNum = x.prevHourCrashNum || 0;
          issueCompareCrashDevices = x.prevHourCrashDevices || 0;
        } else if (topIssueCompareType === TopIssueCompareType.CUSTOM) {
          issueCompareCrashNum = x.compareDateCrashNum || 0;
          issueCompareCrashDevices = x.compareDateCrashDevices || 0;
        }

        const fluctuate = TopIssueUtils.calcFluctuatePercentage(x.crashUser, accessDevices, x.preDayCrashUser, globalCompareDateAccessDevices);
        return {
          ...x,
          exceptionMessage: x.exceptionMessage || '-',
          keyStack: x.keyStack || '-',
          fluctuate,
          formattedFluctuatePercentage: TopIssueUtils.formatPercentage(fluctuate),
          fluctuateDecimal: fluctuate / 100,
          firstUploadTimestamp: x.firstUploadTimestamp,
          formattedFirstUploadTime: moment(TimeUtil.fixChaosMillis(x.firstUploadTimestamp)).format('YYYY-MM-DD HH:mm:ss'),
          formattedCrashUser: formatEnNumber(x.crashUser),
          crashUserFluctuate: TopIssueUtils.calcFluctuatePercentageOfTwoValues(x.crashUser, issueCompareCrashDevices),
          crashNumFluctuate: TopIssueUtils.calcFluctuatePercentageOfTwoValues(x.crashNum, issueCompareCrashNum),
          toAllCrashDevicesFormattedPercentage: formatRate(x.crashUser, crashDevices),
          toAllCrashDevicesPercentageFluctuate: TopIssueUtils.calcFluctuatePercentage(x.crashUser, crashDevices, issueCompareCrashDevices, globalCompareDateCrashDevices),
          toAllCrashDevicesProportionDecimal: (x.crashUser / crashDevices) || 0,
          toAllAccessDevicesFormattedPercentage: formatRate(x.crashUser, accessDevices),
          toAllAccessDevicesPercentageFluctuate: TopIssueUtils.calcFluctuatePercentage(x.crashUser, accessDevices, issueCompareCrashDevices, globalCompareDateAccessDevices),
          toAllAccessDevicesProportionDecimal: (x.crashUser / accessDevices) || 0,
          issueWebsiteUrl: `${window.location.origin}/${getIssueDetailUrlPrefix(x.type)}/${x.appId}/${x.issueId}?pid=${x.platformId}&crashDataType=${topIssueDataType}`,
          commaJoinedTagNames: (x.tags || []).map(x => x.tagName).join(', '),
        }
      });
  },
});

const ProcessorLabel = ({ processor }) => {
  return (<Tooltip title={processor}>
    <div className={_style.processor_list}>{processor}</div>
  </Tooltip>);
}

function makeDefaultTopIssueFilterData() {
  return [
    { name: 'tagList', value: { isMustNot: false, value: [] } },
  ];
}
const TOP_ISSUE_FILTER_FIELD_WHITELIST = ['tagList', 'status'];

const MemoSingleOrRangeDatePicker = React.memo(SingleOrRangeDatePicker);

const JANK_MIN_DEVICE_COUNT_OPTIONS = [0, 1, 5, 10, 50, 100, 500, 1000].map(x => ({ label: x, value: x }));

const MIN_JANK_TIME_OPTIONS = [0, 500, 1000, 1500, 2000, 5000].map(x => ({ label: x, value: x }));

function makeTitleWithTooltip(title, tip) {
  return <div style={{display: 'flex', justifyContent: 'center'}}>
    <span style={{paddingRight: '4px'}}>{ title }</span>
    <Tooltip title={tip}>
      <WrappedTipsIcon />
    </Tooltip>
  </div>;
}

const MemoIssueTrendBarChart = React.memo(IssueTrendBarChart);

const TopIssueList = ({
  reduxState,
  pageType,
  style, handleChangeStatus, demoApp, topIssueDataType, actions,
  bigDataResultDailyUpdateMillis, topIssueCount, searchParams, selectOptions, hasIntegratedApps,
  isRegionalDashboard,
  enableUserSceneTag,
  onClickUpsertTapdBugByIssueIdList, onDownloadData, onTopIssueCountChange, onTopIssueSortFieldChange,
  onBugUnbind, onTopIssueVersionChange, onTopIssueParamsChange, onTopIssueCountryChange,
  onTopIssueEnableFilterChange, handleTopIssueDataTypeChange, onTopIssueFilterRawSearchChange,
  onTopIssueIntegratedAppIdChange,
  onTopIssueVmTypeListChange,
  onTopIssueJankTypeChange,
  onTopIssueCompareDateChange,
}) => {
  const { t } = useTranslation();
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [itemIndexToIsHovering, updateItemIndexToIsHovering] = useImmer({})

  const headRef = useRef(null);
  // 为了解决TopIssueList渲染太重导致大盘统计页面整体卡顿的问题，现在只渲染TopIssueList的头部，表格内容只有滚动到页面下方的时候才渲染
  const [headInViewport] = useInViewport(headRef);

  const data = useMemo(() => {
    return reduxState.summary.get('topIssueData').toJS();
  }, [reduxState.summary.get('topIssueData')]);
  const issueIds = ((data || {}).topIssueList || []).map(x => x.issueId);

  const issueIdToDailyTrendList = useMemo(() => {
    return reduxState.issue.get('issueIdToDailyTrendList') || {};
  }, [reduxState.issue.get('issueIdToDailyTrendList')]);

  const isJankCategory = ExceptionCategoryUtil.isJank(pageType);

  const jankTypeOptions = useMemo(() => {
    return [
      { label: ze('原始上报', 'Raw'), value: TopIssueJankType.RAW },
      { label: ze('拆分后上报', 'Parsed'), value: TopIssueJankType.PARSED },
      { label: ze('合并问题', 'Merged'), value: TopIssueJankType.MERGED_ISSUE },
    ];
  }, []);

  const [
    datePickerMinAvailableMoment,
    datePickerMaxAvailableMoment
  ] = useSelector(selectCurrentAppDatePickerAvailableMomentRange);

  const currentApp = useMemo(() => reduxState.app.get('current').toJS(), [reduxState.app.get('current')]);
  const { appId, name: appName, teamType } = currentApp;
  const isWangZhe = teamType === BillingTeamType.TENCENT && appName?.startsWith('王者');
  const bugTrackingSimplifiedInfo = useMemo(() => reduxState.app.get('appIdToBugTrackingSimplifiedInfo')?.[appId],
    [reduxState.app, appId]);
  const { tapdWorkspaceId, jiraProjectId } = bugTrackingSimplifiedInfo || {};
  const showBugStatusField = !!tapdWorkspaceId || !!jiraProjectId;

  const serverAppSettings = useMemo(() => reduxState.app.get('appIdToServerAppSettings')?.[appId] || {},
    [reduxState.app, appId]);
  // 是否是先锋云游戏项目
  const isAppGameMatrix = !!serverAppSettings[ServerAppSettings.keys.isAppGameMatrix];

  // 王者卡顿定制需求，显示issue的topForm自定义关键字的值的占比
  const issueIdToWangZheTopFormList = useMemo(() => {
    return reduxState.issue.get('issueIdToWangZheTopFormList');
  }, [reduxState.issue]);
  // 王者卡顿，虚拟issue ID -> 子issue list
  const mergedIssueIdToSubJankTopIssueData = useMemo(() => {
    const v = reduxState.summary.get('mergedIssueIdToSubJankTopIssueData');
    return v || {};
  }, [reduxState.summary]);

  const [isExpand, setIsExpand] = useState(false);
  const [columnTooltipVisible, setColumnTooltipVisible] = useState(false);

  const topIssueCountOptions = [20, 50, 100, 200]
    .map(x => ({ label: t(`DATATYPESELECT.topN`, { n: x }), value: x }));

  const sortFieldOptions = [
    { label: ze('按设备数', 'By Affected Devices'), value: TopIssueSortField.DEVICE_COUNT },
    { label: ze('按次数', 'By Reports'), value: TopIssueSortField.REPORT_COUNT },
    isJankCategory && { label: ze('按平均卡顿时长', 'By Jank Time'), value: TopIssueSortField.JANK_TIME },
  ].filter(x => x);
  const { topIssueSortField, pid } = searchParams.toJS();
  const { rankVersion, integratedAppOptions, integratedAppIdToVersionTree } = selectOptions.toJS();

  const members = useMemo(() => {
    return selectOptions.get('processor')?.options || [];
  }, [selectOptions.get('processor')]);

  const versionListValue = searchParams.get('topIssueVersion') !== ALL_VERSION
    ? CsvUtil.singleLineParse(searchParams.get('topIssueVersion'))
    : [];
  const isMultipleVersions = VersionUtil.isMultipleVersions(versionListValue);

  const topIssueIntegratedAppIdValue = searchParams.get('topIssueIntegratedAppId') !== ALL_VERSION
    ? searchParams.get('topIssueIntegratedAppId')
    : null;
  const isQueryIntegratedApp = isNotNullish(topIssueIntegratedAppIdValue);
  const versionTree = isQueryIntegratedApp
    ? integratedAppIdToVersionTree[topIssueIntegratedAppIdValue] || []
    : rankVersion.versionTree;

  const vmTypeListValue = VmTypeUtil.vmSelectValueToVmTypeList(searchParams.get('topIssueVmSelectValue'));

  const momentRange = useMemo(() => {
    const { topIssueDate, topIssueMaxDate } = searchParams.toJS();
    const minMoment = topIssueDate ? moment(topIssueDate) : moment();
    const maxMoment = topIssueMaxDate ? moment(topIssueMaxDate) : minMoment;
    return [minMoment, maxMoment]
  }, [searchParams]);
  const isMultipleDates = !momentRange[0].isSame(momentRange[1]);
  const disabledDate = useCallback(moment => moment && (moment.isBefore(datePickerMinAvailableMoment) || moment.isAfter(datePickerMaxAvailableMoment)), []);
  const onDateChanged = useCallback(([minDate, maxDate]) => {
    console.log('SingleOrRangeDatePicker', minDate, maxDate)
    onTopIssueParamsChange({
      topIssueDate: minDate ? minDate.format('YYYYMMDD') : null,
      topIssueMaxDate: (maxDate && !maxDate.isSame(minDate)) ? maxDate.format('YYYYMMDD') : null,
    })
  }, []);

  const countryList = searchParams.get('topIssueCountry') && searchParams.get('topIssueCountry') !== '-1'
    ? searchParams.get('topIssueCountry').split(',')
    : [];

  const topIssueUserSceneTagList = (searchParams.get('topIssueUserSceneTag') || '').split(',').filter(x => x);

  const topIssueEnableFilterValue = Number(searchParams.get('topIssueEnableFilter') || 0);

  const topIssueEnableCrashFilterValue = Number(searchParams.get('topIssueEnableCrashFilter') || 0);

  const topIssueJankType = Number(searchParams.get('topIssueJankType')) || null;
  const isViewMergedJankIssue = topIssueJankType === TopIssueJankType.MERGED_ISSUE;

  const {
    compareType: topIssueCompareType,
    customDateStr: topIssueCustomCompareDateStr,
  } = TopIssueUtils.parseTopIssueCompareDateStr(searchParams.get('topIssueCompareDate'), TopIssueCompareType.PREV_DAY);

  const topIssueMinDeviceCount = Number(searchParams.get('topIssueMinDeviceCount') || 0);

  const topIssueMinJankTime = Number(searchParams.get('topIssueMinJankTime') || 0);

  const topIssueWangZheExpNameType = Number(searchParams.get('topIssueWangZheExpNameType') || 0);

  const tagListReduxState = reduxState.issue.get('selectOptions').get('tagList');
  const tagListOptions = useMemo(() => (tagListReduxState.get ? tagListReduxState.get('options').toJS() : tagListReduxState.options)
    .map(x => ({ ...x, value: `${x.value}` }))
    .filter(x => x.value !== 'all'), [tagListReduxState]);
  const issueStatusReduxState = reduxState.issue.get('selectOptions').get('status');
  const issueStatusOptions = useMemo(() => (issueStatusReduxState.get ? issueStatusReduxState.get('options') : issueStatusReduxState.options).filter(x => x.value !== 'all'), [issueStatusReduxState]);
  const bundleIdReduxState = reduxState.issue.get('selectOptions').get('bundleIdList');
  const bundleIdOptions = useMemo(() => (bundleIdReduxState.get ? bundleIdReduxState.get('options').toJS() : bundleIdReduxState.options).filter(x => x.value && x.value !== 'all'), [bundleIdReduxState]);

  const [topIssueFilterData, setTopIssueFilterData] = useState(makeDefaultTopIssueFilterData());

  const [topIssueCrashFilterScg, setTopIssueCrashFilterScg] = useState({
    conditions: [],
  });

  const [mergedJankIssueExpandedIssueId, setMergedJankIssueExpandedIssueId] = useState(null);
  const [subJankIssueFlameGraphModalVisible, setSubJankIssueFlameGraphModalVisible] = useState(false);
  const [flameGraphMergedIssueId, setFlameGraphMergedIssueId] = useState(null);

  const showExceptionCategoryTag = ExceptionCategoryUtil.isCrash(pageType) && !!searchParams.get('isQueryVital');

  useEffect(() => {
    const topIssueFilterRawSearchJsonStr = searchParams.get('topIssueFilterRawSearchJsonStr');
    if (!topIssueFilterRawSearchJsonStr) {
      setTopIssueFilterData(makeDefaultTopIssueFilterData());
      return;
    }
    const filterData = IssueCrashFilterUtil.makeFilterDataFromQueryDict(JSON.parse(topIssueFilterRawSearchJsonStr))
      .filter(x => TOP_ISSUE_FILTER_FIELD_WHITELIST.includes(x.name));
    setTopIssueFilterData(filterData);
  }, [searchParams.get('topIssueFilterRawSearchJsonStr')]);

  useEffect(() => {
    const topIssueCrashFilterScgStr = searchParams.get('topIssueCrashFilterScgStr');
    if (!topIssueCrashFilterScgStr) {
      setTopIssueCrashFilterScg({ conditions: [] });
      return;
    }
    try {
      const scg = JSON.parse(topIssueCrashFilterScgStr);
      setTopIssueCrashFilterScg(scg);
    } catch (e) {
      setTopIssueCrashFilterScg({ conditions: [] });
    }
  }, [searchParams.get('topIssueCrashFilterScgStr')]);

  useDeepCompareEffect(() => {
    actions.fetchMultipleIssueTrend(issueIds,IssueListTrendTypeEnum.DAILY);
    if(issueIds.length && !isExpand) {
      setIsExpand(true);
    }
  }, [issueIds]);

  async function fetchSubJankTopIssues(issueId) {
    await actions.getTopIssue({
      limit: 200,
      mergedJankIssueIdList: [issueId],
      queryMergedJankIssue: false,
      jankType: 0,
    });
  }

  function renderMergedIssueIdColumn(record) {
    const { issueId } = record;
    const isExpanded = mergedJankIssueExpandedIssueId === issueId;
    return <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      { issueId }
      { isExpanded && <Button
        style={{ padding: '0' }}
        type="link"
        onClick={() => {
          setFlameGraphMergedIssueId(issueId);
          setSubJankIssueFlameGraphModalVisible(true);
        }}
      >查看火焰图</Button> }
    </div>
  }

  function getExceptionCategory(issueExceptionType) {
    return ExceptionCategoryUtil.fromExceptionTypeInt(issueExceptionType);
  }

  const columnsTable = [
    isViewMergedJankIssue && {
      dataIndex: 'expandedAction',
      title: '',
      width: '60px',
      fixed: 'left',
      render: (_, record) => {
        const { issueId, isMergedJankIssue } = record;
        if (!isMergedJankIssue) {
          return null;
        }
        const isExpanded = mergedJankIssueExpandedIssueId === issueId;
        return <Button
          style={{ padding: '0' }}
          type="link"
          onClick={() => {
            setMergedJankIssueExpandedIssueId(isExpanded ? null : issueId);
            if (!isExpanded) {
              fetchSubJankTopIssues(issueId);
            }
          }}
        >{ isExpanded ? '收起' : '展开'}</Button>;
      },
    },
    {
      dataIndex: 'top',
      title: t("TOPISSUELIST.top"),
      width: isViewMergedJankIssue ? '60px' : '50px',
      fixed: 'left',
    },
    {
      dataIndex: 'issue',
      title: t("TOPISSUELIST.issue"),
      width: 300,
      fixed: 'left',
      render: (_, { item }) => (item.isMergedJankIssue ? renderMergedIssueIdColumn(item) : <div className={_style.hidden_none}>
        <div className={`${_style.problem_box}`}>
          <Tooltip trigger={[]} placement='bottom' overlayStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.9)', minWidth: '800px' }} title={(<div>
            <ul>
              <li className={_style.problem_list}>
                <span className={_style.problem_itemName}>{ t("TOPISSUELIST.exceptionType") }:</span>
                <span className={_style.problem_itemContent}>{item.exceptionName}</span>
              </li>
              <li className={_style.problem_list}>
                <span className={_style.problem_itemName}>{ t("TOPISSUELIST.exceptionInfo") }:</span>
                <span className={_style.problem_itemContent}>{item.exceptionMessage}</span>
              </li>
              <li className={_style.problem_list}>
                <span className={_style.problem_itemName}>{ t("TOPISSUELIST.stack") }:</span>
                <span className={_style.problem_itemContent}>{item.keyStack}</span>
              </li>
            </ul>
          </div>)}
          >
            <div>
              <div className={_style.problem_name}>
                <div>
                  <a
                    {...(item.isOpenIssueInNewTab && { target: '_blank' })}
                    rel="noopener noreferrer"
                    data-top-issue-jump={item.topIssueJumpKind || 'plain'}
                    href={item.issueWebsiteUrl}
                    className={_style.link_item}
                    style={{display:'flex',alignItems:'center'}}
                    onClick={() => {
                      reportEvent({
                        action: EVENT_ACTIONS.CLICK,
                        tp1: '每日TOP问题点击链接',
                        tp6: item.issueWebsiteUrl,
                      })
                    }}
                  >
                    <Space className={_style.error_title} size={4}>
                      { showExceptionCategoryTag && <div className={SearchItemScss[`type_logo_${getExceptionCategory(item.issueInfo?.issueExceptionType)?.toLowerCase()}`]}>
                        {getExceptionCategory(item.issueInfo?.issueExceptionType)}
                      </div> }
                      {<div style={{margin: '-2px 4px 0 0'}}>{<IssueIdIcon />}</div>}
                      {
                        <Tooltip arrow={true}
                          placement="top"
                          title={(<div>{ item.issueId }</div>)}
                        >
                          {<div className={_style.error_title_id}>{item.issueId}</div>}
                        </Tooltip>
                      }
                      {<div style={{margin: '-2px 4px 0 4px'}}>{<IssueNameIcon />}</div>}
                      {
                        <Tooltip arrow={true}
                          placement="top"
                          title={(<div>{ item.exceptionName }</div>)}
                        >
                          {<div className={_style.error_title_type}>{item.exceptionName}</div>}
                        </Tooltip>
                      }
                    </Space>
                  </a>
                </div>
              </div>
              { false && <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', lineHeight: 'normal' }}>{ item.keyStack }</div> }
              <CsClampDiv
                style={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere', lineHeight: '16px' }}
                lineHeight={1.15}
                lineClamp={3}
                showButton={!!itemIndexToIsHovering[item.i]}
              >
                { item.keyStack }
              </CsClampDiv>
            </div>
          </Tooltip>
        </div>
        { !isViewMergedJankIssue && <div>
          <TagList
          {...{
            tags:item.tags, addTag:item.addTag, delTag:item.delTag, issueId:item.issueId, appId:item.appId, pid: item.platformId,
            issueVersions:item.issueVersions,
            firstUploadTimestamp:item.firstUploadTimestamp,
            aiStatus: item.issueInfo?.esMap?.aiStatus,
          }}
          />
        </div> }
        <WangZheTopFormList
          issueId={item.issueId}
          issueIdToWangZheTopFormList={issueIdToWangZheTopFormList}
        />
      </div>)
    },
    isViewMergedJankIssue && {
      dataIndex: 'subJankIssueCount',
      title: ze('子问题数', 'Sub Issues'),
      width: 80,
      align: 'right',
    },
    isJankCategory && {
      dataIndex: '',
      title: ze('平均卡顿时长(ms)', 'Avg Jank Time(ms)'),
      width: 120,
      align: 'right',
      render: (_, {item}) => {
        const jankTime = item.jankTime || 0;
        return <div style={{position: 'relative'}}>
          { jankTime.toFixed(2) }
        </div>;
      },
    },
    {
      dataIndex: FIELDS.DEVICES,
      title: ix(t("TOPISSUELIST.affectedDevices")),
      sorter: true,
      width: isZh() ? 110 : 140,
      align: 'center',
      render: (_,{item}) => (
        <div style={{ position: 'relative' }}>
          <div>{`${item.formattedCrashUser} `}</div>
          <div>
            { TopIssueUtils.makeFluctuateDom(item.crashUserFluctuate) }
          </div>
        </div>
      )
    },
    {
      dataIndex: 'toAllCrashDevicesPercentageFluctuate',
      title: (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <span style={{paddingRight: 4}}>{ t("TOPISSUELIST.proportion") }</span>
          <Tooltip title={ze('影响设备数/影响设备总数（所选时间范围）','Affected Devices / Total Affected Devices (on selected day)')}>
            <WrappedTipsIcon />
          </Tooltip>
        </div>
      ),
      width: isZh() ? 88 : 96,
      align: 'center',
      render: (_,{item}) => (
        <div style={{ position: 'relative' }}>
          <div>{`${item.toAllCrashDevicesFormattedPercentage} `}</div>
          <div>
            { TopIssueUtils.makeFluctuateDom(item.toAllCrashDevicesPercentageFluctuate) }
          </div>
        </div>
      )
    },
    {
      dataIndex: 'toAllAccessDevicesFormattedPercentage',
      title: (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <span style={{paddingRight: 4}}>{ t("TOPISSUELIST.issueReportRate") }</span>
          <Tooltip title={ze('影响设备数/联网设备数（所选时间范围）','Affected Devices / Total Active Devices (on selected day)')}>
            <WrappedTipsIcon />
          </Tooltip>
        </div>
      ),
      width: isZh() ? 100 : 160,
      align: 'center',
      render: (_,{item}) => (
        <div style={{ position: 'relative' }}>
          <div>{`${item.toAllAccessDevicesFormattedPercentage} `}</div>
          <div>
            { TopIssueUtils.makeFluctuateDom(item.toAllAccessDevicesPercentageFluctuate) }
          </div>
        </div>
      )
    },
    {
      dataIndex: FIELDS.REPORT_COUNT,
      title: (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <span style={{paddingRight: 4}}>{ t("REALTIMETOPISSUE.occurNum") }</span>
          <Tooltip title={ze('上报数量（所选日期范围内）','Report(on selected day)')} onOpenChange={(e) => {
            setColumnTooltipVisible(e);
          }}>
            <WrappedTipsIcon />
          </Tooltip>
        </div>
      ),
      width: isZh() ? 110 : 90,
      paddingLeft:'40px',
      align: 'center',
      sorter: true,
      render: (text, record) => (
        <div style={{ minWidth: '80px', position: 'relative' }}>
          <div>{ formatEnNumber(record.reportCount) }</div>
          <div>
            { TopIssueUtils.makeFluctuateDom(record.crashNumFluctuate) }
          </div>
        </div>
      )
    },
    {
      dataIndex: FIELDS.TOTAL_DEVICES,
      title: makeTitleWithTooltip(ix(t("TOPISSUELIST.userAffectTotal")), ze('问题对应累计值，与所选版本和日期范围无关', 'Cumulative value for the issue, regardless of the selected version and date range.')),
      width: isZh() ? 135 : 190,
      align: 'center',
      sorter: true,
      render: (_, {item}) => (
        item.isMergedJankIssue ? '-' :
        <div style={{ position: 'relative' }}>{formatNum(item.accumulateCrashUser)}</div>
      )
    },
    {
      dataIndex: FIELDS.TOTAL_NUM,
      title: makeTitleWithTooltip(ix(t("TOPISSUELIST.numAffectTotal")), ze('问题对应累计值，与所选版本和日期范围无关', 'Cumulative value for the issue, regardless of the selected version and date range.')),
      width: isZh() ? 135 : 195,
      align: 'center',
      sorter: true,
      render: (_, {item}) => (
        item.isMergedJankIssue ? '-' :
        <div style={{ position: 'relative' }}>{formatNum(item.accumulateCrashNum)}</div>
      )
    },
    {
      dataIndex: FIELDS.FIRST_TIME,
      title: makeTitleWithTooltip(t("TOPISSUELIST.firstPostTime"), ze('问题首次上报时间，与所选版本和日期范围无关', 'The time when the issue was first reported, regardless of the selected version and date range.')),
      sorter: true,
      width: isZh() ? 135 : 175,
      align: 'center',
      render: (_, {item}) => (
        item.isMergedJankIssue ? '-' :
        <div>{item.formattedFirstUploadTime}</div>
      )
    },
    !isViewMergedJankIssue && {
      dataIndex: 'issueTrendBarChart',
      title: makeTitleWithTooltip(t('TOPISSUELIST.reportedTrends'), ze('问题最近14天累计上报趋势，与所选版本和日期范围无关', 'The cumulative reporting trend of issues in the last 14 days, regardless of the selected version and date range')),
      align: 'center',
      width: '200px',
      render: (_,{item}) => (
        <div style={{ height:'80px',}}>
         <MemoIssueTrendBarChart
            trendType={IssueListTrendTypeEnum.DAILY}
            dailyTrendList={issueIdToDailyTrendList[item.issueId]}
          />
        </div>
      )
    },
    {
      dataIndex: 'disposeState',
      title: t("TOPISSUELIST.status"),
      width: '200px',
      align: 'center',
      render: (_, {item}) => {
        if (item.isMergedJankIssue) {
          return null;
        }
        return <StatusItem
          assigneeList={item.assigneeList}
          statusNo={item.statusNo}
          appId={item.appId}
          pid={item.platformId}
          issueId={item.issueId}
          handleChangeStatus={() => { !DemoUtil.checkAndWarnIfDemoApp(demoApp) && handleChangeStatus(item)}}
        />
      }
    },
    showBugStatusField && {
      dataIndex: 'tapdStatus',
      title: <div>
        { !!tapdWorkspaceId && ze('TAPD状态', 'Tapd Status') }
        { !!jiraProjectId && ze('Jira缺陷单状态', 'Jira Issue Status') }
      </div>,
      width: '120px',
      align: 'center',
      render: (_, { item }) => {
        if (item.isMergedJankIssue) {
          return null;
        }
        const record = item;
        const bugInfo = record.bugs && record.bugs[0];
        if (bugInfo) {
          return <IssueTapdBugStatusEx
            needQueryStatus={true}
            currentApp={currentApp}
            issueId={record.issueId}
            tapdBugInfo={record.bugs && record.bugs[0]}
            onBugUnbind={() => onBugUnbind()}
          />;
        } else  {
          return <Button
            type='link'
            style={{padding: '0', color: CS_STYLES.PRIMARY_COLOR }}
            onClick={() => onClickUpsertTapdBugByIssueIdList([record.issueId])}>{ ze('创建', 'Create')}
          </Button>;
        }
      },
    },
  ].filter(x => x);

  const clientHeight = document.body.clientHeight;
  const tableHeight = Math.max(clientHeight - 72 - 60 - 52 - 250, 300);

  function renderTopIssueList(data, style, handleChangeStatus, members, demoApp, topIssueDataType, actions, sortField, sortOrder, topIssueCompareType) {
    if (!data || !data.topIssueList || data.topIssueList.length < 1) {
      return [];
    }

    const { addTag, delTag } = actions;

    const isOpenIssueInNewTab = !process.env.REACT_APP_IS_WETEST_IFRAME && !getIsIframe();
    const rawCountryGroups = reduxState.summary.get('countryGroupConfigList');
    const countryGroupConfigList = rawCountryGroups && rawCountryGroups.toJS
      ? rawCountryGroups.toJS()
      : (rawCountryGroups || []);

    function attachJump(item) {
      const built = buildTopIssueWebsiteUrl({
        origin: window.location.origin,
        issueDetailPathPrefix: getIssueDetailUrlPrefix(item.type),
        appId: item.appId,
        issueId: item.issueId,
        platformId: item.platformId,
        crashDataType: topIssueDataType,
        vmTypeSupported: PlatformUtil.isVmTypeSupported(pid),
        vmTypeList: vmTypeListValue,
        versionList: versionListValue,
        countryEnabled: !!isRegionalDashboard,
        countryList,
        countryGroupConfigList,
        sceneEnabled: !!enableUserSceneTag,
        sceneList: topIssueUserSceneTagList,
        minDate: momentRange[0] ? momentRange[0].format('YYYYMMDD') : '',
        maxDate: isMultipleDates && momentRange[1] ? momentRange[1].format('YYYYMMDD') : '',
        defaultDate: moment().format('YYYYMMDD'),
        issueFilterEnabled: !!topIssueEnableFilterValue,
        issueFilterData: topIssueFilterData,
      });
      return {
        ...item,
        issueWebsiteUrl: built.url,
        topIssueJumpKind: built.jumpKind,
      };
    }

    let topIssueEnrichedIssueList = TopIssueUtils.makeTopIssueEnrichedIssueList(data, topIssueDataType, topIssueCompareType)
      .map((x, i) => attachJump({
        ...x,
        top: i + 1,
      }));

    if (sortField && sortOrder) {
      topIssueEnrichedIssueList.sort((a, b) => {
        let ascRes = 0;
        if (sortField === FIELDS.FLUCTUATE) {
          ascRes = a.fluctuate - b.fluctuate;
        } else if (sortField === FIELDS.FIRST_TIME) {
          ascRes = a.firstUploadTimestamp - b.firstUploadTimestamp;
        } else if (sortField === FIELDS.TOTAL_DEVICES) {
          ascRes = a.accumulateCrashUser - b.accumulateCrashUser;
        } else if (sortField === FIELDS.TOTAL_NUM) {
          ascRes = a.accumulateCrashNum - b.accumulateCrashNum;
        } else if (sortField === FIELDS.REPORT_COUNT) {
          ascRes = a.crashNum - b.crashNum;
        } else if (sortField === FIELDS.DEVICES) {
          ascRes = a.crashUser - b.crashUser;
        }
        return sortOrder === 'ascend' ? ascRes : -ascRes;
      });
    }

    if (isViewMergedJankIssue) {
      const groups = topIssueEnrichedIssueList.map(issue => {
        issue = {
          ...issue,
          isMergedJankIssue: true,
        };
        const mergedIssueId = issue.issueId;
        const subJankTopData = mergedIssueIdToSubJankTopIssueData[mergedIssueId];
        if (mergedJankIssueExpandedIssueId !== issue.issueId) {
          return [issue];
        } else {
          const subIssues = (subJankTopData ? TopIssueUtils.makeTopIssueEnrichedIssueList(subJankTopData, topIssueDataType, topIssueCompareType) : [])
            .map((subIssue, i) => attachJump({
              top: `${issue.top}-${i + 1}`,
              ...subIssue,
            }));
          return [
            issue,
            ...subIssues,
          ];
        }
      });
      topIssueEnrichedIssueList = groups.flat();
    }

    return topIssueEnrichedIssueList.map((item, i) => {
      const { issueId, tags, appId, issueVersions, firstUploadTimestamp, fluctuate } = item;
      const platformId = item.platformId || item.pid;

      const { assigneeList } = item.issueInfo || {};

      const statusNo = getStatus(item.state);
      const assigneeListDisplayText = convertIssueAssigneeListToDisplayText(assigneeList);
      let arrowClassName = '';
      if (fluctuate > 0) {
        arrowClassName = 'increase';
      } else if (fluctuate < 0) {
        arrowClassName = 'decrease';
      }
      item.fluctuate = fluctuate;
      item.arrowClassName = arrowClassName;
      item.style = style;
      item.assigneeListDisplayText = assigneeListDisplayText;
      item.assigneeList = assigneeList;
      item.isOpenIssueInNewTab = isOpenIssueInNewTab;
      item.addTag = addTag;
      item.delTag = delTag;
      item.actions = actions;
      item.i = i;
      item.pid = platformId;
      item.statusNo = statusNo;
      return {
        ...item,
        key: issueId,
        reportCount: item.crashNum,
        item: item,
        issue: item,
        influenceFacility: item,
        issueAnomalyFluctuate: item,
        appearTime: item,
        influenceEquipment: item,
        influenceFrequency: item,
        disposeState: item,
      };
    });
  }

  const topIssueListTableData = useMemo(() => {
    return renderTopIssueList(data, style, handleChangeStatus, members, demoApp, topIssueDataType, actions, sortField, sortOrder, topIssueCompareType);
  }, [
    data,
    members,
    topIssueDataType,
    sortField,
    sortOrder,
    mergedIssueIdToSubJankTopIssueData,
    topIssueCompareType,
  ]);
  let mergedJankIssueList = [];
  if (isJankCategory) {
    mergedJankIssueList = topIssueListTableData.filter(x => x.isMergedJankIssue);
  }

  return (
    <div
      ref={headRef}
    >
      <CardHead
        title={t("DATATYPESELECT.dailyTopIssue")}
        hideDivider={!isExpand}
        svgIcon={<TopIssuesIcon />}
        iconExtraStyle={{width: '18px', height: '17px'}}
      >
        <div
          style={{display: 'flex', flexGrow: '1', alignItems: 'center', justifyContent: 'flex-end'}}
        >
          <UpdateTimeTag updateTime={bigDataResultDailyUpdateMillis} />
          <CsDownloadButton
            style={{ margin: '0px 24px'}}
            onClick={(e) => {
              e.stopPropagation();
              reportEvent({
                action: EVENT_ACTIONS.CLICK,
                tp1: '每日TOP问题-下载',
              });
              onDownloadData({isMultipleDates});
            }}
          />
           <CsCollapseButton
              extraStyle={{ width: '14px', height: '14px' }}
              isCollapsed={!isExpand}
              enableHover={true}
              onClick={(e) => {
                e.stopPropagation();
                const newIsExpand = !isExpand;
                setIsExpand(newIsExpand);
                ReportEventUtil.reportCardHeadClickEvent('每日TOP问题', true, newIsExpand);
              }}
            />
        </div>
      </CardHead>
      {
        isExpand && headInViewport && <>
          <Row gutter={[10, 6]} align='middle' style={{ marginTop: '20px'}}>
            <Col>
              <Select
                style={{ width: '200px' }}
                options={sortFieldOptions}
                value={topIssueSortField || TopIssueSortField.DEVICE_COUNT}
                onChange={(value) => {
                  if (value === 'REPORT_COUNT') {
                    reportEvent({
                      action: EVENT_ACTIONS.CLICK,
                      tp1: '每日TOP问题-按次数',
                    });
                  }
                  onTopIssueSortFieldChange(value);
                }}
              />
            </Col>
            <Col>
              <Select
                style={{ width: '110px' }}
                options={topIssueCountOptions}
                value={topIssueCount}
                onChange={(v) => onTopIssueCountChange(v)}
              />
            </Col>
            {
              PlatformUtil.isVmTypeSupported(pid) && <Col>
                <VmTypeSelect
                  value={vmTypeListValue}
                  onChange={(v) => onTopIssueVmTypeListChange(v)}
                />
              </Col>
            }
            <Col>
              <VersionHybridSelect
                style={{ width: '320px' }}
                value={versionListValue}
                treeData={versionTree}
                onChange={(v) => onTopIssueVersionChange(CsvUtil.singleLineStringify(v) || ALL_VERSION)}
              />
            </Col>
            <Col>
              <MemoSingleOrRangeDatePicker
                style={{ width: '220px'}}
                disabledDate={disabledDate}
                allowClear={false}
                value={momentRange}
                onChange={onDateChanged}
              />
            </Col>
            { hasIntegratedApps && <Col flex={null}>
              <Select
                allowClear={true}
                showSearch
                style={{ width: '160px' }}
                options={integratedAppOptions}
                placeholder={ze('所有接入项目', 'All Integrated App')}
                value={topIssueIntegratedAppIdValue}
                onChange={(v) => onTopIssueIntegratedAppIdChange(v || ALL_VERSION)}
              />
            </Col> }
            { isRegionalDashboard &&  <Col>
                <CountrySelect
                  style={{width: '320px'}}
                  value={countryList}
                  isMultiple={true}
                  onChangeWhenDropdownClosed={(v) => onTopIssueCountryChange(CountryUtil.listToQueryString(v))}
                />
              </Col>
            }
            { enableUserSceneTag && <Col>
              <UserSceneTagSelect
                isMultiple={true}
                style={{ width: '320px' }}
                value={topIssueUserSceneTagList}
                onChangeWhenDropdownClosed={v => onTopIssueParamsChange({ topIssueUserSceneTag: (v || []).join(',') })}
              />
            </Col> }
            { isJankCategory && <Col flex={null}>
              <Select
                style={{ width: '160px' }}
                options={jankTypeOptions}
                value={topIssueJankType}
                onChange={(v) => onTopIssueJankTypeChange(v)}
              />
            </Col> }
            <Col><VitalOrCrashSelect /></Col>
          </Row>
          {
            (isMultipleVersions || isMultipleDates) && <div style={{ margin: '20px 0', width: '100%', color: orange.primary, fontSize: '12px' }}>
            <Space>
              <ExclamationCircleOutlined/>
              <div>{ t('EXCP_OVERVIEW.multipleVersionsDatesWarning')}</div>
            </Space>
            </div>
          }
          {
            <Row gutter={[10, 6]} align='middle' style={{ marginTop: '24px' }}>
              <Col>
                <span style={{ paddingLeft: '4px', paddingRight: '16px', color: '#807997'}}>{ze('对比', 'Comparison')}</span>
                <Radio.Group
                  options={[
                    { label: t("TOPISSUELIST.dayOnDayGrowth"), value: TopIssueCompareType.PREV_DAY },
                    { label: ze('自定义日期', 'Custom'), value: TopIssueCompareType.CUSTOM },
                  ]}
                  value={topIssueCompareType}
                  onChange={(e) => {
                    const v = e.target.value;
                    reportEvent({
                      action: EVENT_ACTIONS.CLICK,
                      tp1: '点击切换top问题对比',
                    });
                    if (v !== TopIssueCompareType.CUSTOM) {
                      onTopIssueCompareDateChange(v);
                    } else {
                      onTopIssueCompareDateChange(moment().subtract(1, 'days').format('YYYYMMDD'));
                    }
                  }}
                />
                { topIssueCompareType === TopIssueCompareType.CUSTOM && <DatePicker
                  style={{ width: '220px', cursor: 'pointer' }}
                  allowClear={false}
                  disabledDate={moment => moment && (moment.isBefore(datePickerMinAvailableMoment) || moment.isAfter(datePickerMaxAvailableMoment))}
                  value={moment(topIssueCustomCompareDateStr, 'YYYYMMDD')}
                  suffixIcon={
                    <DateSelectIcon style={{ width: '12px', height: '12px' }} />
                  }
                  onChange={(v) => {
                    const dateStr = v.format('YYYYMMDD');
                    onTopIssueCompareDateChange(dateStr);
                  }}
                /> }
              </Col>
              { platformUtils.isMobile(pid) && <Col>
                <span style={{ paddingLeft: '4px', paddingRight: '16px', color: '#807997'}}>{t("DATATYPESELECT.增加问题过滤条件")}</span>
                <Radio.Group
                  options={[
                    { label: t("common.yes"), value: 1 },
                    { label: t("common.no"), value: 0 },
                  ]}
                  value={topIssueEnableFilterValue}
                  onChange={(e) => {
                    if (e.target.value) {
                      reportEvent({
                        action: EVENT_ACTIONS.CLICK,
                        tp1: '增加问题过滤条件'
                      });
                    }
                    onTopIssueEnableFilterChange(e.target.value);
                  }}
                />
              </Col> }
              { isAppGameMatrix && <Col>
                <span style={{ paddingLeft: '4px', paddingRight: '16px', color: '#807997'}}>{ze('增加上报过滤条件', 'Add Report Filter')}</span>
                <Radio.Group
                  options={[
                    { label: t("common.yes"), value: 1 },
                    { label: t("common.no"), value: 0 },
                  ]}
                  value={topIssueEnableCrashFilterValue}
                  onChange={(e) => {
                    if (e.target.value) {
                      reportEvent({
                        action: EVENT_ACTIONS.CLICK,
                        tp1: '增加上报过滤条件'
                      });
                    }
                    onTopIssueParamsChange({ topIssueEnableCrashFilter: e.target.value });
                  }}
                />
              </Col> }
              { platformUtils.isMobile(pid) && !isJankCategory && <Col>
                <Tooltip placement="top" arrowPointAtCenter={true} title={ze('点击查看关键字列表','click and view keywords list')}>
                  <span style={{ paddingLeft: '4px', paddingRight: '16px'}}>
                    <a
                      target="_blank"
                      style={{color: '#807997'}}
                      rel="noopener noreferrer"
                      href={DocsUtil.makeDocsUrl('/terms/#SystemExitKeywords')}
                    >{t("DATATYPESELECT.matchSysExitKW")}
                    </a>
                  </span>
                  <Radio.Group
                    options={[
                      { label: t("common.yes"), value: 'systemExit' },
                      { label: t("common.no"), value: 'unSystemExit' },
                    ]}
                    value={topIssueDataType}
                    onChange={(e) => {
                      if (e.target.value === 'systemExit') {
                        reportEvent({
                          action: EVENT_ACTIONS.CLICK,
                          tp1: '匹配到系统退出关键字'
                        });
                      }
                      handleTopIssueDataTypeChange(e.target.value);
                    }}
                  />
                </Tooltip>
              </Col> }
              { isJankCategory && <Col>
                <span style={{ paddingLeft: '4px', paddingRight: '16px', color: '#807997'}}>{ze('影响设备数 ≥ ', 'Affected Devices ≥')}</span>
                <Select
                  size='small'
                  style={{ width: '80px' }}
                  options={JANK_MIN_DEVICE_COUNT_OPTIONS}
                  value={topIssueMinDeviceCount}
                  onChange={(v) => onTopIssueParamsChange({ topIssueMinDeviceCount: v })}
                />
              </Col> }
              {/** 王者定制需求，按expName过滤局内和局外 */}
              { isJankCategory && isWangZhe && <Col>
                <span style={{ paddingLeft: '4px', paddingRight: '16px', color: '#807997'}}>局内/局外</span>
                <Select
                  size='small'
                  style={{ width: '80px' }}
                  options={WangZheExpNameTypeOptions}
                  value={topIssueWangZheExpNameType}
                  onChange={(v) => onTopIssueParamsChange({ topIssueWangZheExpNameType: v })}
                />
              </Col> }
              {/** 王者定制需求，按照卡顿时长过滤 */}
              { isJankCategory && isWangZhe && <Col>
                <span style={{ paddingLeft: '4px', paddingRight: '16px', color: '#807997'}}>卡顿时长(ms) &gt;= </span>
                <Select
                  size='small'
                  style={{ width: '80px' }}
                  options={MIN_JANK_TIME_OPTIONS}
                  value={topIssueMinJankTime}
                  onChange={(v) => onTopIssueParamsChange({ topIssueMinJankTime: v })}
                />
              </Col> }
            </Row>
          }
          { !!topIssueEnableFilterValue && <div style={{marginTop: '20px'}}>
              <IssueCrashFilter
                platformId={pid}
                maxConditions={2}
                fieldWhitelist={['tagList', 'status']}
                filterOptions={{
                  tagList: tagListOptions,
                  status: issueStatusOptions,
                }}
                filterData={topIssueFilterData}
                onChange={({ newFilterData }) => { setTopIssueFilterData(newFilterData); }}
                onSubmit={({ newFilterData }) => {
                  setTopIssueFilterData(newFilterData);
                  const rawSearch = pickBy(IssueCrashFilterUtil.makeQueryDictFromFilterData(newFilterData), isNotNullish);
                  onTopIssueFilterRawSearchChange(rawSearch);
                }}
              />
            </div>
          }
          { !!topIssueEnableCrashFilterValue && <div style={{marginTop: '20px'}}>
            <IssueCrashFilterEx
              platformId={pid}
              maxConditions={5}
              fieldWhitelist={[FieldName.bundleId, FieldName.gmCluster, FieldName.gmHardware, FieldName.gmGameId, FieldName.gmGameCluster]}
              filterOptions={{
                bundleId: bundleIdOptions,
              }}
              searchConditionGroup={topIssueCrashFilterScg}
              onChange={({ searchConditionGroup }) => { setTopIssueCrashFilterScg(searchConditionGroup); }}
              onSubmit={({ searchConditionGroup }) => {
                setTopIssueCrashFilterScg(searchConditionGroup);
                onTopIssueParamsChange({ topIssueCrashFilterScgStr: JSON.stringify(searchConditionGroup) });
              }}
            />
          </div>
          }
          {
            isJankCategory && <SubJankIssueFlameGraphModal
              visible={subJankIssueFlameGraphModalVisible}
              onClose={() => setSubJankIssueFlameGraphModalVisible(false)}
              mergedIssueId={flameGraphMergedIssueId}
              mergedIssueList={mergedJankIssueList}
              onFetchSubJankTopIssues={fetchSubJankTopIssues}
            />
          }
          <Translation>
            {
              (t, { i18n }) => <div className={_style.topIssueList}>
                { !data || !data.topIssueList || data.topIssueList.length < 1
                  ? <EmptyData text={ t("TOPISSUELIST.noData") } extraStyle={{paddingTop: 32, paddingBottom: 42}} />
                  : (
                    <Table className={_style.custom_table} size="small" columns={columnsTable} pagination={false}
                      showSorterTooltip={false}
                      dataSource={topIssueListTableData}
                      // showSorterTooltip={columnTooltipVisible ? { style: { display: "none" } } : true}
                      rowClassName = {record => {
                        const item = record.item;
                        return (
                          Number(item.statusNo) === 1 ? style.done : style.item
                        )
                      }}
                      scroll={{
                          y: `${tableHeight}px`,
                          x: '1560px',
                        }}
                      onRow = {record => {
                        return {
                          onMouseEnter:(event) => {
                            updateItemIndexToIsHovering(draft => ({ ...draft, [(record.top)-1]: true }));
                          },
                          onMouseLeave:(event) => {
                            updateItemIndexToIsHovering(draft => ({ ...draft, [(record.top)-1]: false }));
                          }
                        }
                      }}
                      onChange = {(pagination, filters, sorter) => {
                        const { order, field } = sorter;
                        setSortField(field || null);
                        setSortOrder(order || null);
                      }}
                    />
                  )
                }
              </div>
            }
          </Translation>
        </>
      }
      { isExpand && !headInViewport && <div
        style={{ height: tableHeight }}
      /> }
    </div>
  );
};

TopIssueList.propTypes = {
  style: PropTypes.object,
  demoApp: PropTypes.bool,
  handleChangeStatus: PropTypes.func,
  actions: PropTypes.object,
};

const mapStateToProps = state => ({
  reduxState: state,
});

export default connect(mapStateToProps)(TopIssueList);
